import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { authedRoute } from '../../app/routes-base';

export const gudangRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: 'gudang',
  component: lazyRouteComponent(() => import('./layout'), 'GudangLayout'),
});

const overviewRoute = createRoute({
  getParentRoute: () => gudangRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./pages/overview-page'), 'OverviewPage'),
});

export const gudangTree = gudangRoute.addChildren([overviewRoute]);
